import { Badge, BadgeOrigin, Tooltip } from "@mui/material";
import { Component } from "react";
import TickIcon from "../resources/images/icons-check-circle-fill.svg";
import WarningIcon from "../resources/images/icons-warning-circle-fill.svg";

interface ComplianceBadgeProps {
  isCompliant?: boolean;
  children?: React.ReactNode;
  anchorOrigin?: BadgeOrigin;
}

export class ComplianceBadge extends Component<ComplianceBadgeProps> {
  render() {
    const { isCompliant, children, anchorOrigin } = this.props;

    return (
      <Badge
        badgeContent={
          isCompliant ? (
            <Tooltip title='Compliant' placement='top'>
              <div className='klayo_profilepic_compliantbadge'>
                <TickIcon />
              </div>
            </Tooltip>
          ) : (
            <Tooltip title='Non-compliant' placement='top'>
              <div className='klayo_profilepic_noncompliantbadge'>
                <WarningIcon />
              </div>
            </Tooltip>
          )
        }
        anchorOrigin={anchorOrigin}
      >
        {children}
      </Badge>
    );
  }
}
